const show = ({
  id = 'pipeLoadingOverlay',
  classToShow = 'pipe-show',
  classToHide = 'pipe-hide',
} = {}) => {
  const overlayEl = document.getElementById(id)

  if (!overlayEl) {
    console.error(`Overlay element with the following id not found: ${id}`)
    return
  } 
  document.getElementById(id).classList.add(classToShow)
  document.getElementById(id).classList.remove(classToHide)
}

const hide = ({
  id = 'pipeLoadingOverlay',
  classToShow = 'pipe-show',
  classToHide = 'pipe-hide',
} = {}) => {
  const overlayEl = document.getElementById(id)

  if (!overlayEl) {
    console.error(`Overlay element with the following id not found: ${id}`)
    return
  } 
  document.getElementById(id).classList.add(classToHide)
  document.getElementById(id).classList.remove(classToShow)
}

export { show, hide }
